module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Bushman-Web-1280.3336b512.jpg";